import React from "react";
import LoginLink from "./LoginLink";
import { Product } from "~/common/Store/models/ProductListing";
import GetPriceByEmail from "./GetPriceByEmail";
import Price from "../Price";

interface Props {
  mapPrice: number;
  type: string;
  price: Product["price"];
  priceCrossedOut?: boolean;
  itemNumber: string;
  unitOfMeasure: string;
  showLoginLink: boolean;
  priceTextSize?: "standard" | "small" | "custom";
  productListingView?: string;
}

const LoginOrEnterEmail = ({
  price,
  itemNumber,
  unitOfMeasure,
  showLoginLink,
  priceTextSize = "standard",
  productListingView = "grid",
}: Props) => {
  return (
    <>
      <Price
        price={price.price}
        unitOfMeasure={unitOfMeasure}
        className="strikeOutPrice"
        style={{ textDecoration: "line-through" }}
        textSize={priceTextSize}
      />
      <p className="price enter-email">
        {showLoginLink ? (
          <>
            <LoginLink>Login</LoginLink>
            {" or enter your email to be instantly sent the price!"}
          </>
        ) : (
          "Enter your email to be instantly sent the price!"
        )}
      </p>
      <div className="input-append">
        <GetPriceByEmail
          itemNumber={itemNumber}
          className={
            productListingView === "list"
              ? "justify-start xs:justify-center"
              : "justify-center"
          }
        />
      </div>
    </>
  );
};

export default LoginOrEnterEmail;
